import React, { Component } from 'react';
import Icon from './Icon';

class NewButton extends Component {

      returnCSS(){
        return "button-" + this.props.type + " " + (this.props.selected ? "button-selected " :"") +  (this.props.processing ? "button-processing" : "") + " " + (this.props.css ? "button-" + this.props.css : "new-button-rounded" )
    }

//   returnCSS(){

//     let cls = "new-button-" + this.props.type;

//     if(this.props.selected)
//         cls += " new-button-selected";

//     if(this.props.processing)
//         cls += " new-button-processing";

//     cls += this.props.css
//         ? " new-button-" + this.props.css
//         : " new-button-rounded";

//     return "new-img-btn " + cls;
// }

renderButton(){
    return (
        <button 
            disabled={this.props.processing}
           className={this.returnCSS() + " btn-h34"}
            onClick={this.props.onClick}
            style={{ marginBottom: 0 }} 
        >
            {this.props.icon && <Icon type={this.props.icon}/>}
            {!this.props.processing && <div>{this.props.text}</div>}
            {this.props.processing && <i className="fa fa-spinner fa-spin"/>}
        </button>
    );
}

    renderLink(){
        return <a className={"button-" + this.props.type} onClick={this.props.onClick}>{this.props.text}</a>
    }

    render(){
        return <React.Fragment>
            {(this.props.type==="primary" || this.props.type==="secondary") && this.renderButton()}
            {this.props.type==="link" && this.renderLink()}
            {(this.props.type==="remove" &&   <button 
        onClick={this.props.onClick}
        disabled={this.props.processing || this.props.disabled}
        className="btn btn-default btn-flat"
        style={{ height: "34px" }}   // 👈 height applied
    >
        Remove selected <i className="fa fa-trash-o"></i>
    </button>)}
        </React.Fragment>
    }
}

export default NewButton